// src/constants/colors.js
// Shared green & white design system for all dashboards
const COLORS = {
    primary: '#1B3A2F', // Deep Green (Main UI color, sidebar active state, headers)
    primaryDark: '#122A22', // Hover/pressed state for primary green
    secondary: '#4C7A62', // Mid Green (secondary accents, icons)
    accent: '#2F855A', // Bright Green (highlights, success, links)
    text: '#1A1A1A', // Near-black text for strong contrast
    textSecondary: '#6B7280', // Neutral grey secondary text
    white: '#FFFFFF', // White for backgrounds & cards
    background: '#F7F9F8', // Neutral off-white canvas (slight green-grey undertone)
    surface: '#FFFFFF', // Card / surface background
    surfaceMuted: '#F1F4F2', // Muted green-grey surface (table stripes, chips)
    danger: '#B3261E', // Red for error messages and warnings
    warning: '#B7791F', // Amber for pending/warning states
    border: '#E3E8E5', // Neutral border with faint green undertone
};

export default COLORS;
